<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.999999940395355,2C13.449999940395355,2,12.999999940395355,2.45,12.999999940395355,3C12.999999940395355,3,12.999999940395355,6,12.999999940395355,6C12.999999940395355,7.66,11.659999940395355,9,9.999999940395355,9C9.999999940395355,9,4.409999940395355,9,4.409999940395355,9C4.409999940395355,9,5.699999940395355,7.71,5.699999940395355,7.71C5.889999940395355,7.53,5.999999940395355,7.28,5.999999940395355,7C5.999999940395355,6.45,5.549999940395355,6,4.999999940395355,6C4.719999940395356,6,4.469999940395356,6.11,4.289999940395355,6.29C4.289999940395355,6.29,1.2899999403953553,9.29,1.2899999403953553,9.29C1.1099999403953553,9.469999999999999,0.9999999403953552,9.719999999999999,0.9999999403953552,10C0.9999999403953552,10.28,1.1099999403953553,10.53,1.2899999403953553,10.71C1.2899999403953553,10.71,4.289999940395355,13.71,4.289999940395355,13.71C4.469999940395356,13.89,4.719999940395356,14,4.999999940395355,14C5.549999940395355,14,5.999999940395355,13.55,5.999999940395355,13C5.999999940395355,12.72,5.889999940395355,12.47,5.709999940395355,12.29C5.709999940395355,12.29,4.409999940395355,11,4.409999940395355,11C4.409999940395355,11,9.999999940395355,11,9.999999940395355,11C12.759999940395355,11,14.999999940395355,8.76,14.999999940395355,6C14.999999940395355,6,14.999999940395355,3,14.999999940395355,3C14.999999940395355,2.45,14.549999940395356,2,13.999999940395355,2C13.999999940395355,2,13.999999940395355,2,13.999999940395355,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'KeyEnter',
} as DefineComponent
</script>
